const display = (icon, rest = {}) => ({
    icon,
    tokenIconKey: null,
    label: null,
    showNumber: false,
    displayPrice: 0,
    launchPrice: 0,
    tokenName: null,
    ...rest,
});
export const getPriceDisplay = (priceInfo, eventTokens = []) => {
    const displayPrice = priceInfo?.displayPrice ?? 0;
    const launchPrice = priceInfo?.launchPrice ?? 0;
    const priced = { showNumber: true, displayPrice, launchPrice };
    switch (priceInfo?.source) {
        case "sbc":
            return display("sbc", priced);
        case "tokens": {
            const token = eventTokens.find((eventToken) => eventToken.eventTokenId === priceInfo.tokenId);
            return token
                ? display("token", {
                    ...priced,
                    tokenIconKey: token.iconKey,
                    tokenName: token.displayName,
                })
                : display(null, priced);
        }
        case "objective":
            return display("objective");
        case "market":
            // Extinct: no market quote.
            return displayPrice > 0
                ? display("coin", priced)
                : display("coin", { label: "-" });
        default:
            // No backend-resolved source: the player has no price (evolved/builder).
            return display("coin");
    }
};
/**
 * The objective price cell for an objective player:
 *
 * - **Season reward** (rewardArea `SEASON` with `spRequired`) → season-points
 *   icon + the points.
 * - **Group reward** (rewardArea `GROUP` with a resolved `objectiveGroupName`) →
 *   objective icon + the group name.
 * - Anything else — a missing/incomplete objective — → the bare objective icon.
 */
export const getObjectiveDisplayInfo = (objectiveDisplay) => {
    if (objectiveDisplay?.rewardArea === "SEASON" &&
        objectiveDisplay.spRequired != null) {
        return {
            icon: "sp",
            spRequired: objectiveDisplay.spRequired,
            groupName: null,
        };
    }
    if (objectiveDisplay?.rewardArea === "GROUP" &&
        objectiveDisplay.objectiveGroupName) {
        return {
            icon: "objective",
            spRequired: null,
            groupName: objectiveDisplay.objectiveGroupName,
        };
    }
    return { icon: "objective", spRequired: null, groupName: null };
};
/**
 * The one-line price on a player card: the season objective's points (icon +
 * required amount) when the player is a season reward, otherwise the price
 * display. A tradeable market price always wins over the season points.
 */
export const getCardPriceDisplay = ({ priceInfo, objectiveDisplay, eventTokens, }) => {
    const price = getPriceDisplay(priceInfo, eventTokens);
    const hasMarketPrice = priceInfo?.source === "market" && priceInfo.displayPrice > 0;
    if (!hasMarketPrice &&
        objectiveDisplay?.rewardArea === "SEASON" &&
        objectiveDisplay.spRequired) {
        return {
            icon: "sp",
            tokenIconKey: null,
            label: price.label,
            tokenName: null,
            price: objectiveDisplay.spRequired,
            showPrice: true,
        };
    }
    return {
        icon: price.icon,
        tokenIconKey: price.tokenIconKey,
        label: price.label,
        tokenName: price.tokenName,
        price: price.displayPrice,
        showPrice: price.showNumber,
    };
};
/** `players` namespace key of the price cell's label per source. */
export const PRICE_SOURCE_LABEL_KEYS = {
    objective: "detailed.currentState.priceSource.objective",
    sbc: "detailed.currentState.priceSource.sbc",
    tokens: "detailed.currentState.priceSource.tokens",
    market: "detailed.currentState.priceSource.market",
};
//# sourceMappingURL=priceDisplay.js.map